module.exports = "<div *ngIf=\"textContent\" class=\"long-text-content\" >\n<p #textContentElement id=\"textContentElement\" [innerHtml]=\"textContent\">\n\n</p>\n<div  class=\"read-more-link\">\n  <a readMore [readMore-length]=\"200\" [readMore-element]=\"textContentElement\">\n    <span class=\"less\">کمتر <i class=\"fa fa-angle-up\" aria-hidden=\"true\"></i></span>\n    <span class=\"more\">بیشتر <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i></span>\n  </a>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/long-text/long-text.template.html
// module id = 968
// module chunks = 3